import { getInstance } from '@portal/repositories/securitySdkConfig';

const V3_BASE_URL = '/v3/home';

const HomeApi = {
  get: async (): Promise<models.HomeResponse> => {
    const instance = getInstance();
    const { data } = await instance.get<models.HomeResponse>(V3_BASE_URL);

    return data;
  },
};

export default HomeApi;
